import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
// Station-page `--sp-*` theme tokens (light + derived dark) — global so
// the /__visual fixtures and the /:locale/station route share one source.
import './components/stationPage/stationPageTheme.css'
import App from './App.tsx'
import { installI18nFromPath } from './i18n/install'
// Side-effect import bootstraps i18next (HttpBackend + LanguageDetector +
// initReactI18next). Must run before App mounts so the very first
// `useTranslation()` call has a configured instance.
import './i18n/config'
import { initCookieConsent } from './cookie/consent'
import { startWebVitalsReporting } from './analytics/webVitalsEvents'
import { reportAnalyticsEvent } from './analytics/webAnalyticsReporter'

// Apply the path-segment locale before React mounts so `<html lang>` /
// `<html dir>` are set on first paint and i18next is seeded with the
// correct namespace (avoids a flash of fallback strings on /:locale/
// routes other than the default).
installI18nFromPath()

// Cookie consent window (InMobi Choice, IAB TCF) for every visitor, and
// the analytics it gates where the city has web analytics.
// See src/cookie/consent.ts.
initCookieConsent()

// Core Web Vitals of this page load → `web_vitals_reported` (TASK-1173).
// Production-only like every emit (`reportAnalyticsEvent`).
startWebVitalsReporting(reportAnalyticsEvent)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
